import type { RouteRecordRaw } from "vue-router";

import { APP_SETTINGS_SUBSCRIPTIONS_ROUTES } from "@/Generated/Routes/paths";
import { buildBeforeEnterChain, isPatientGuard } from "@/Router/guards";

const subscriptions: RouteRecordRaw[] = [
  {
    ...APP_SETTINGS_SUBSCRIPTIONS_ROUTES.payment.root,
    meta: {
      i18nTitle: "user.settings.subscription.payment.payment-title",
    },
    component: () => import("@/Views/settings/subscription/payment/Payment.vue"),
    beforeEnter: buildBeforeEnterChain(isPatientGuard),
  },
  {
    ...APP_SETTINGS_SUBSCRIPTIONS_ROUTES.payment.add.root,
    meta: {
      i18nTitle: "user.settings.subscription.payment.add_payment_method",
    },
    component: () => import("@/Views/settings/subscription/payment/add/AddPaymentMethod.vue"),
    beforeEnter: buildBeforeEnterChain(isPatientGuard),
  },
  {
    ...APP_SETTINGS_SUBSCRIPTIONS_ROUTES.plan.root,
    meta: {
      i18nTitle: "user.settings.subscription.plan.plan-title",
    },
    component: () => import("@/Views/settings/subscription/plan/Plan.vue"),
    beforeEnter: buildBeforeEnterChain(isPatientGuard),
  },
  {
    ...APP_SETTINGS_SUBSCRIPTIONS_ROUTES.privatePlan.root,
    meta: {
      i18nTitle: "user.settings.subscription.plan.plan-title",
    },
    component: () => import("@/Views/settings/subscription/plan/Plan.vue"),
    beforeEnter: buildBeforeEnterChain(isPatientGuard),
  },
  {
    ...APP_SETTINGS_SUBSCRIPTIONS_ROUTES.promoCode.root,
    meta: {
      i18nTitle: "settings.subscription.patient.promo_code.insert_promotional_code",
    },
    component: () => import("@/Views/settings/subscription/promo-code/PromoCode.vue"),
    beforeEnter: buildBeforeEnterChain(isPatientGuard),
  },
  {
    ...APP_SETTINGS_SUBSCRIPTIONS_ROUTES.cancel.root,
    meta: {
      i18nTitle: "settings.subscription.patient.cancel",
    },
    component: () => import("@/Views/settings/subscription/cancel/Cancel.vue"),
    beforeEnter: buildBeforeEnterChain(isPatientGuard),
  },
  {
    ...APP_SETTINGS_SUBSCRIPTIONS_ROUTES.cancel.reason.root,
    meta: {
      i18nTitle: "settings.subscription.patient.cancel",
    },
    component: () => import("@/Views/settings/subscription/cancel/CancelReason.vue"),
    beforeEnter: buildBeforeEnterChain(isPatientGuard),
  },
  {
    ...APP_SETTINGS_SUBSCRIPTIONS_ROUTES.sessions.root,
    meta: {
      i18nTitle: "settings.subscription.sessions_payments_records",
    },
    component: () => import("@/Views/settings/subscription/sessions/Sessions.vue"),
    beforeEnter: buildBeforeEnterChain(isPatientGuard),
  },
];

export default subscriptions;
